import Utils from '../../modules/utils'

const getShippedOn = (callbackFunc) => {
  const url = 'shipped_on'

  let orderIds = Object.keys(window.shippedOn).filter(orderId => window.shippedOn[orderId] == '⏳')

  const data = {orderIds}

  Utils.post(url, data, callbackFunc)
}

export {getShippedOn}
